
import React from 'react'
import Layout from "../components/utils/layout";

const MccLists = () => {
    const screenId="MccLists"
    const charts = {
        transactions_by_mcc : {},
        vaping_mcc : {},
        mcc_codes : {}
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default MccLists